import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//产品树
export async function productTree(params) {
    return post(erpserver+'/product/productTree', params, true)
}
//列表
export async function getStockList(params) {
    return post(erpserver+'/storekc/getStockList', params, true)
}
export async function getStockDetail(params) {
    return post(erpserver+'/storekc/getStockDetail', params, true)
}
export async function getList(params) {
    return post(erpserver+'/storekw/getList', params, true)
}
export async function editStock(params) {
    return post(erpserver+'/storekc/editStock', params, true)
}
